var _rect, _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 20,
    viewBox: "0 0 26 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.0395508,
    width: 25.3104,
    height: 19.3071,
    rx: 2.17,
    fill: "#DBB931"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.35 2.67571C25.35 1.19796 24.1534 0 22.6774 0H2.71208C1.23608 0 0.0395508 1.19796 0.0395508 2.67571V16.6314C0.0395508 18.1091 1.23608 19.3071 2.71208 19.3071H22.6774C24.1534 19.3071 25.35 18.1091 25.35 16.6314V2.67571ZM2.71204 0.432875H22.6774L22.809 0.436683C23.985 0.504901 24.9176 1.48128 24.9176 2.67575V16.6314L24.9138 16.7632C24.8457 17.9406 23.8705 18.8743 22.6774 18.8743H2.71204L2.58041 18.8705C1.40445 18.8023 0.471835 17.8259 0.471835 16.6314V2.67575L0.475638 2.54396C0.543775 1.3666 1.519 0.432875 2.71204 0.432875Z",
    fill: "#646464"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6943 17.4871C12.9982 17.4871 13.2446 17.2391 13.2446 16.9332C13.2446 16.6273 12.9982 16.3793 12.6943 16.3793C12.3904 16.3793 12.1441 16.6273 12.1441 16.9332C12.1441 17.2391 12.3904 17.4871 12.6943 17.4871Z",
    fill: "#646464"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.64635 6.74374V7.17658H0.216095V6.74374H8.64635Z",
    fill: "#646464"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0548 12.4014V12.8342H16.546V12.4014H25.0548Z",
    fill: "#646464"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0551 6.74374V7.17658H16.7034V6.74374H25.0551Z",
    fill: "#646464"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8064 0.666565C14.8997 1.41345 16.2492 3.42716 16.864 6.67617L16.9163 6.96605L16.8954 7.1021C16.2441 8.36472 16.1702 10.0834 16.685 12.2609L16.7555 12.5475L16.7564 12.6513C16.0594 15.5746 14.8158 17.5401 13.0188 18.531L12.8309 18.6301L12.6857 18.6477C11.6243 18.4049 10.6353 17.4068 9.67843 15.7769C9.61793 15.6739 9.65232 15.5412 9.75524 15.4807C9.85816 15.4201 9.99063 15.4545 10.0511 15.5576C10.912 17.0239 11.7842 17.9313 12.6572 18.1928L12.7069 18.2058L12.8119 18.1509C14.4304 17.2573 15.5833 15.4915 16.2647 12.8385L16.3232 12.6008L16.2661 12.3681C15.7499 10.1892 15.7999 8.42469 16.4263 7.07693L16.4773 6.97098L16.4386 6.7535C15.8678 3.73846 14.6637 1.87687 12.8346 1.14007L12.7361 1.10216L12.6471 1.13854C10.9769 1.85367 9.73403 3.71979 8.93239 6.7574L8.87148 6.9929L8.93599 7.17824C9.59567 9.1606 9.53287 10.942 8.74198 12.5104L8.63932 12.7053C8.60894 12.7607 8.5564 12.7992 8.49624 12.8125L8.44991 12.8175H0.21616C0.0967783 12.8175 0 12.7206 0 12.6011C0 12.4986 0.0711025 12.4128 0.166597 12.3904L0.21616 12.3846L8.31961 12.3845L8.35977 12.3079C9.09159 10.8512 9.14952 9.19304 8.52799 7.32152L8.44307 7.0762L8.43665 6.95058C9.26462 3.61662 10.6074 1.53862 12.4804 0.73913L12.6576 0.667923L12.8064 0.666565Z",
    fill: "#646464"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChip);
export default __webpack_public_path__ + "static/media/Chip.03fb5a3e1ab12ecb9c7bfbb44d142393.svg";
export { ForwardRef as ReactComponent };